import type { SummaryData } from '@xing-com/crate-jobs-helpers';

import { JobsXingletWrapper } from '../../../jobs-xinglet';

import { AiJobSummarySkeleton } from './ai-job-summary-skeleton';

export type AiJobSummaryProps = {
  summaryData?: SummaryData;
  jobGlobalId: string;
};

export const AiJobSummary = JobsXingletWrapper<AiJobSummaryProps>(
  '@xing-com/crate-jobs-domain-job-details-ai-job-summary',
  <AiJobSummarySkeleton />
);
